// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__F3un_","tag":"style_tag__z8jY2"};